import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
import { TOP_BANNER_DESKTOP_HEIGHT, TOP_BANNER_MOBILE_HEIGHT } from "./constants";
export var Root = styled('div')(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    textColor = _ref.textColor,
    theme = _ref.theme;
  return _defineProperty({
    background: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.palette.common.white,
    color: textColor !== null && textColor !== void 0 ? textColor : theme.palette.text.primary,
    height: TOP_BANNER_MOBILE_HEIGHT,
    overflow: 'hidden',
    position: 'relative'
  }, theme.breakpoints.up('sm'), {
    height: TOP_BANNER_DESKTOP_HEIGHT
  });
});
export var BreadcrumbsRoot = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    margin: theme.spacing(4, 0, 0, 3),
    position: 'relative',
    zIndex: 10
  }, theme.breakpoints.up('sm'), {
    margin: theme.spacing(7, 0, 0, 6)
  });
});
export var TitleRoot = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  left: '50%',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  top: '50%',
  width: '100%',
  zIndex: 10
});
export var Title = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    display: '-webkit-box',
    fontFamily: 'SansCondensedOri, SansCondensedOriFallback, SansOri, SansOriFallback, sans-serif',
    fontSize: theme.typography.pxToRem(30),
    fontWeight: theme.typography.fontWeightBold,
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    width: '80%'
  }, theme.breakpoints.up('sm'), {
    fontSize: theme.typography.pxToRem(50),
    WebkitLineClamp: 2
  });
});
export var Image = styled('img')({
  height: '100%',
  left: 0,
  objectFit: 'cover',
  objectPosition: '50% 50%',
  position: 'absolute',
  top: 0,
  width: '100%'
});
//# sourceMappingURL=styles.js.map